import mutations from './mutations'
import actions from './actions'

const state = {
  all_payment_methods: [],
  payment_methods: [],
  payment_method: [],
  deleted_payment_methods: [],
  payment_gateways: [],
  jenga_auth: [], 
  payment_options: [],
  mpesa_transactions: []
  
}

export default {
  state, mutations, actions
}
